import { Checkbox } from "@/components/ui/checkbox";
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldError,
  FieldLabel,
} from "@/components/ui/field";
import type { ComponentProps } from "react";

interface ICustomCheckboxProps extends ComponentProps<typeof Checkbox> {
  label: string;
  description?: string;
  error?: string;
}

const CustomCheckbox = ({
  id,
  label,
  description,
  error,
  ...props
}: Readonly<ICustomCheckboxProps>) => {
  return (
    <Field orientation="horizontal">
      <Checkbox id={id} aria-invalid={!!error} {...props} />
      <FieldContent>
        <FieldLabel htmlFor={id}>{label}</FieldLabel>
        {description && <FieldDescription>{description}</FieldDescription>}
        {error && <FieldError className="text-xs">{error}</FieldError>}
      </FieldContent>
    </Field>
  );
};

export default CustomCheckbox;
